export default "__VITE_PUBLIC_ASSET__072e43a2__"